<template>
    <div class="topic-content">
        <p class="headline" v-html="topic.headlineText"></p>
        <SubtopicShortcuts :topic="topic" />
        <ContentBox class="main-text">
            <div v-html="topic.mainText"></div>
        </ContentBox>
        <div
            class="embed-wrapper main-video"
            v-if="topic.mainVideoSrc !== ''"
            v-html="topic.mainVideoSrc"
        ></div>
        <SubtopicContent
            v-for="subtopic in availableSubtopics"
            v-bind:key="subtopic.order"
            :subtopic-icon-src="subtopic.iconPath"
            :subtopic-title="subtopic.title"
            :subtopic-data="getSubtopicData(subtopic)"
            :id="subtopic.id"
        />
        <div class="do-you-know-title">
            <h2>Czy wiesz, że...</h2>
        </div>
        <AdvancedBox
            v-for="advancedSubtopic in topic.czyWieszSection"
            v-bind:key="advancedSubtopic.text"
        >
            <template v-slot:content>
                <span v-html="advancedSubtopic.text"></span>
            </template>
            <template v-slot:more-content>
                <span v-html="advancedSubtopic.more"></span>
            </template>
        </AdvancedBox>
    </div>
</template>

<script>
    import SubtopicShortcuts from '@/components/SubtopicShortcuts';
    import ContentBox from '@/components/ContentBox';
    import SubtopicContent from '@/components/SubtopicContent';
    import { subtopics } from '@/model/topics-data';
    import AdvancedBox from '@/components/AdvancedBox';
    export default {
        name: 'TopicContent',
        components: { AdvancedBox, SubtopicContent, ContentBox, SubtopicShortcuts },
        props: {
            topic: Object,
        },
        data: function () {
            return {};
        },
        computed: {
            availableSubtopics: function () {
                let availableSubtopics = [];
                for (let subtopic of subtopics) {
                    if (this.topic[subtopic.id].length > 0) {
                        availableSubtopics.push(subtopic);
                    }
                }
                return availableSubtopics;
            },
        },
        methods: {
            getSubtopicData: function (subtopic) {
                return this.topic[subtopic.id];
            },
        },
    };
</script>

<style lang="scss">
    @import '../scss/embed-wrapper';

    .topic-content {
        background-color: $light-green;
        padding-bottom: 200px;

        .headline {
            padding: $margin;
            margin: 0;
            background-color: $green;
            color: $white;
        }

        .main-text {
            margin-top: 50px;
            margin-bottom: 50px;
        }

        .main-video {
            margin-bottom: 50px;
        }

        .do-you-know-title {
            margin-top: 80px;
            margin-bottom: 40px;

            h2 {
                font-size: 26px;
                font-weight: bold;
                color: $dark-green;
            }
        }
    }
</style>
